<template>
  <delivery-addresses />
</template>

<script>
import DeliveryAddresses from "@/components/3pl/CRM/CustomerProfile/DeliveryAddresses";
export default {
  components: {
    DeliveryAddresses,
  },
};
</script>

<style></style>
